import { render, staticRenderFns } from "./MonthSetting.vue?vue&type=template&id=6b078dec"
import script from "./MonthSetting.vue?vue&type=script&lang=js"
export * from "./MonthSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports